import React, { useContext } from 'react';
import {
  MyPlan,
  Benefits,
  PlanDocuments,
  CoveredEligibleMembers,
  MemberIdCard,
  EnrollInBenefits,
  MemberProfile,
  Authorizations,
  FormAndDocument,
  MedicalClaims,
  SuperMedicalClaims,
  PharmacyClaims,
  VirtualVisitCare,
  PayYourSentaraBill,
  WellnessPrograms,
  PayMonthlyPremium,
  InterimView,
} from 'pages';
import { GlobalContext, isAvMed } from 'context';
import { useTranslation } from 'react-i18next';
import { MyPlanTabs, NavigateConst, errorhandler, createDynamicUrl } from 'common';
import { useMySSOUrl } from '@sentara-health/sentara-api-hooks-core';
import { FITNESS_MAP_URL } from 'common/utils/constants/Constants';

const UrlLinks = () => {
  const { getFeature, isMemberTabDefault, ssoEndPoints, healthEquityHSA } = useContext(GlobalContext);
  const { t } = useTranslation();
  // JSON to render the Side Menu and toggle for display rule"

  const openUrl = (url: string | undefined) => {
    window.open(url, '_blank');
  };
  const redirectToUrl = (type: string) => {
    if (isAvMed())
      return type
    else
      getAPIUrl(type);
  }

  const { SSOUrlType } = useMySSOUrl();
  const getAPIUrl = async (type: string) => {
    const res = await SSOUrlType(type); // Get SSO URL from API
    if (res?.data?.ssoUrl) {
      window.open(res?.data?.ssoUrl, '_blank'); // Open SSO URL in a new tab
    } else if (res?.errorCode) {
      errorhandler(res?.errorCode);
    }
  };

  const benefitsUrl = [
    {
      id: 1,
      to: isMemberTabDefault
        ? `${NavigateConst.myPlan + MyPlanTabs.memberDetailID}`
        : `${NavigateConst.myPlan + MyPlanTabs.overViewID}`,
      title: t('common.myPlan'),
      onclick: null,
      toggle: getFeature?.YourPlan,
      content: <MyPlan />,
    },
    {
      id: 2,
      to: '/home/benefits',
      title: t('common.benefits'),
      onclick: null,
      toggle: getFeature?.Benefits,
      content: <Benefits />,
    },
    {
      id: 3,
      to: '/home/plan-documents',
      title: t('common.planDocuments'),
      onclick: null,
      toggle: getFeature?.PlanDocuments,
      content: <PlanDocuments />,
    },
    {
      id: 4,
      to: '/home/covered-eligible-members',
      title: t('common.coveredEligibleMembers'),
      onclick: null,
      toggle: getFeature?.CoveredEligibleMembers,
      content: <CoveredEligibleMembers />,
    },
    {
      id: 5,
      to: '/home/member-id-card',
      title: t('common.memberIDCard'),
      onclick: null,
      toggle: getFeature?.MemberidCard,
      content: <MemberIdCard />,
    },
    {
      id: 6,
      to: '#',
      title: t('common.dentalCoverage'),
      onclick: 'DentalDominion',
      toggle: getFeature?.DentalDominion,
      content: null,
    },
    {
      id: 7,
      to: '#',
      title: t('common.manageRenewPolicy'),
      onclick: 'ManageRenewPolicy',
      toggle: getFeature?.ManageorRenewPolicy,
      content: null,
    },
    {
      id: 8,
      to: '#',
      title: t('common.manageHealthSavingsAccount'),
      onclick: 'ManageHSA',
      toggle: getFeature?.ManageHSA && healthEquityHSA,
      content: null,
    },
    {
      id: 9,
      to: '#',
      title: t('common.manageHRA'),
      onclick: 'ManageHRA',
      toggle: getFeature?.ManageHealthReimbursementAccount,
      content: null,
    },
    {
      id: 10,
      to: '/home/enroll-benefits',
      title: t('common.enrollBenefit'),
      onclick: null,
      toggle: getFeature?.EnrollInBenefits,
      content: <EnrollInBenefits />,
    },
    {
      id: 11,
      to: '#',
      title: t('common.visionCare'),
      onclick: 'VisionCare',
      toggle: getFeature?.VisionCare,
      content: null,
    },
    {
      id: 12,
      to: '/home/authorizations',
      title: t('common.authorizations'),
      onclick: null,
      toggle: getFeature?.Authorizations,
      content: <Authorizations />,
    },
    {
      id: 13,
      to: '/home/forms-and-documents',
      title: t('common.formsDocuments'),
      onclick: null,
      toggle: getFeature?.FormsandDocuments,
      content: <FormAndDocument />,
    },
    {
      id: 14,
      to: ssoEndPoints?.employeeAssistanceProgram,
      title: t('common.employeeAssistanceProgram'),
      onclick: null,
      toggle: getFeature?.EmployeeAssistanceProgram,
      content: null,
      target: '_blank',
      referrerPolicy: 'origin-when-cross-origin',
    }
  ];
  const paymentClaims = [
    {
      id: 1,
      to: '/home/pay-your-sentara-bill',
      title: t('common.payYourSentaraBill'),
      onclick: null,
      toggle: getFeature?.PayYourSentaraBill,
      content: <PayYourSentaraBill />,
    },
    {
      id: 2,
      to: '/home/medical-claims',
      title: t('common.medicalClaimsExplanation'),
      onclick: null,
      toggle: getFeature?.MedicalClaims,
      content: getFeature?.SuperEOBMedicalClaims ? <SuperMedicalClaims /> : <MedicalClaims />,
    },
    {
      id: 3,
      to: '/home/behavioral-claims',
      title: t('common.behavioral'),
      onclick: null,
      toggle: getFeature?.BehavioralClaims,
      content: <MedicalClaims />,
    },

    {
      id: 4,
      to: '/home/pharmacy-claims',
      title: t('common.pharmacy'),
      onclick: null,
      toggle: getFeature?.PharmacyClaims,
      content: <PharmacyClaims />,
    },
    {
      id: 5,
      to: () => redirectToUrl(ssoEndPoints?.CalculateTreatmentCostUrl),
      title: t('common.calculateTreatmentCosts'),
      onclick: 'CalculateTreatmentCostUrl',
      toggle: getFeature?.EstimateTreatmentCosts && getFeature?.IBMEstimateTreatmentCosts,
      content: null,
    },
    {
      id: 6,
      to: isAvMed() && getFeature?.PayMonthlyPremiumPage ? '/home/pay-monthly-premium' : () => redirectToUrl(ssoEndPoints?.PayMonthlyPremium),
      title: t('common.payMonthlyPremium'),
      onclick: isAvMed() && getFeature?.PayMonthlyPremiumPage ? null : 'WellsFargo',
      toggle: getFeature?.PayMonthlyPremium,
      content: isAvMed() && getFeature?.PayMonthlyPremiumPage ? <PayMonthlyPremium /> : null,
    },
    {
      id: 7,
      to: ssoEndPoints?.smartShopperURL,
      title: t('common.smartShopper'),
      onclick: null,
      toggle: getFeature?.SmartShopper,
      content: null,
      target: '_blank',
    },
  ];
  const doctorsMedication = [
    {
      id: 1,
      to: NavigateConst.findADoctor,
      title: t('common.findADoctor'),
      onclick: null,
      toggle: getFeature?.FindADoctor,
      content: <InterimView type="findadoc" />,
    },
    {
      id: 2,
      to: ssoEndPoints?.BehavioralHealthProvider,
      title: t('common.behavioralHealthProvider'),
      onclick: null,
      toggle: getFeature?.BehavioralHealthProvider,
      content: null,
      target: '_blank',
    },
    {
      id: 3,
      to: NavigateConst.changePCP,
      title: t('common.changePrimaryCare'),
      onclick: null,
      toggle: getFeature?.ChangePCP,
      content: <InterimView type="changepcp" />,
    },
    {
      id: 4,
      to: getFeature?.PharmacyBenefitsManager ?
        () => getAPIUrl(ssoEndPoints?.PharmacyResources) :
        () => getAPIUrl(ssoEndPoints?.PharmacyOptum),
      title: t('common.pharmacyResources'),
      onclick: 'PharmacyResources',
      toggle: getFeature?.PharmacyResources,
      content: null,
    },
    {
      id: 5,
      to: ssoEndPoints?.rxSavingsURL,
      title: t('common.rxSavings'),
      onclick: null,
      toggle: getFeature?.RxSavings,
      content: null,
      target: '_blank',
    },
    {
      id: 6,
      to: isAvMed() ? ssoEndPoints?.VirtualVisitSSO :
        getFeature?.VirtualFirstHealthPlan ?
          ssoEndPoints?.virtualVisitUrl : '#',
      title: t('common.virtualVisit'),
      onclick: isAvMed() ? null : getFeature?.VirtualFirstHealthPlan ? null : 'VirtualVisit',
      toggle: getFeature?.MDLiveVirtualVisit,
      content: getFeature?.VirtualFirstHealthPlan ? <VirtualVisitCare /> : null,
      target: isAvMed() ? '_blank' : '_self',
    },
    {
      id: 7,
      to: () => openUrl(ssoEndPoints?.HCSEmployeeHealthWellnessURL),
      title: t('common.hcsEmployeeHealthWellnessCtr'),
      onclick: 'HCSEmployeeHealthWellnessCtr',
      toggle: getFeature?.CareATC,
      content: null,
    },
    {
      id: 8,
      to: () => getAPIUrl(ssoEndPoints?.TravelAssistance),
      title: t('common.travelAssistance'),
      onclick: 'TravelAssistance',
      toggle: getFeature?.EmergencyTravelAssistance,
      content: null,
    },
    {
      id: 9,
      to: () => openUrl(ssoEndPoints?.scheduleLabWorkUrl),
      title: t('common.scheduleLabWork'),
      onclick: 'ScheduleLabWork',
      toggle: getFeature?.ScheduleLabWork,
      content: null,
    },
    {
      id: 10,
      to: '/home/hinge-health',
      title: t('common.jointMusclePainReliefProgram'),
      onclick: 'ShowVirtualMSK',
      toggle: getFeature?.ShowVirtualMSK,
      content: null,
    },
  ];

  const getHealthy = [
    {
      id: 1,
      to: () => getAPIUrl(ssoEndPoints?.PersonalHealthRecord),
      title: t('common.personalHealthRecord'),
      onclick: 'PersonalHealthRecord',
      toggle: getFeature?.PersonalHealthRecord,
      content: null,
    },
    {
      id: 2,
      to: () => getAPIUrl(ssoEndPoints?.PersonalHealthAssessment),
      title: t('common.personalHealthAssessment'),
      onclick: 'PersonalHealthAssessment',
      toggle: getFeature?.PersonalHealthAssessment,
      content: null,
    },
    {
      id: 3,
      to: () => getAPIUrl(ssoEndPoints?.WellnessTools),
      title: t('common.wellnessTools'),
      onclick: 'WellnessTools',
      toggle: getFeature?.WellnessTools,
      content: null,
    },
    {
      id: 4,
      to: isAvMed() 
        ? createDynamicUrl(getFeature, FITNESS_MAP_URL, ssoEndPoints?.fitnessURL)
        : ssoEndPoints?.fitnessURL,
      title: t('common.fitnessDiscounts'),
      onclick: null,
      toggle: getFeature?.fitness,
      content: null,
      target: '_blank',
      referrerPolicy: 'origin-when-cross-origin',
    },
    {
      id: 5,
      to: ssoEndPoints?.chooseHealthyURL,
      title: t('common.chooseHealthy'),
      onclick: null,
      toggle: getFeature?.ChooseHealthy,
      content: null,
      target: '_blank',
      referrerPolicy: 'origin-when-cross-origin',
    },
    {
      id: 6,
      to: '#',
      title: t('common.viewCarePlan'),
      onclick: getFeature?.JivaCarePlan
        ? 'ViewCarePlanJiva'
        : { kind: 'visionCarePdf', fileName: t('common.viewCarePlanCase') },
      toggle: getFeature?.ViewCarePlan,
      content: null,
    },
  ];
  const guestBenefitsUrl = [
    {
      id: 1,
      to: '/home/enroll-benefits',
      title: t('common.enrollBenefit'),
      onclick: null,
      toggle: true,
      content: <EnrollInBenefits />,
    },
  ];

  const guestWellnessUrl = [
    {
      id: 1,
      to: '/home/wellness-programs',
      title: t('common.wellnessPrograms'),
      onclick: null,
      toggle: true,
      content: <WellnessPrograms />,
    },
  ];

  const memberProfileUrl = [
    {
      id: 1,
      to: NavigateConst.memberProfile,
      title: t('common.memberProfile'),
      onclick: null,
      toggle: true,
      content: <MemberProfile />,
    },
  ];
  const designatedRepresentativeUrl = [
    {
      id: 1,
      to: '/home/forms-and-documents',
      title: t('common.formsDocuments'),
      onclick: null,
      toggle: true,
      content: <FormAndDocument />,
    },
  ];
  return {
    benefitsUrl,
    paymentCalims: paymentClaims,
    doctorsMedication,
    getHealthy,
    guestBenefitsUrl,
    guestWellnessUrl,
    designatedRepresentativeUrl,
    memberProfileUrl,
  };
};

export default UrlLinks;